import { forwardRef, useState } from "react";
import MDBox from "dashboard/components/MDBox";

import { SmallQuillToolbar, modules, formats } from "./EditorToolbar";
import MDEditorRoot from "./MDEditorRoot";

const MDEditor = forwardRef(({ error, success, disabled,helperText, inputClass,  ...rest }, ref) => {
  
    const [instanceClass] = useState(inputClass)
  
    return    (
        
        <MDBox>
          <SmallQuillToolbar className={instanceClass} />
            <MDEditorRoot 
              theme="snow"
              style={{minHeight: 100}}
              modules={{...modules, toolbar: `.${instanceClass}` }}
              formats={formats}
              {...rest} 
              ref={ref}
              ownerState={{ error, success, disabled }}
            />
            {Boolean(error) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeSmall MuiFormHelperText-contained Mui-required">{helperText}</p>}
        </MDBox>
      )
});


export default MDEditor